/* eslint-disable no-unused-vars */
export class ApiServiceManager {
  getUrl = () => this.path;
  constructor(
    public readonly path: string,
    public readonly method: "POST" | "GET" | "PUT" | "DELETE" | "PATCH",
    public tokenProvider?: () => Promise<string | null>,
    public tokenUpdater?: (token: string) => any
  ) {}
}
export const fetchRequest: <TInput, TOutput>(
  apiServiceManager: ApiServiceManager,
  inputData?: any,
  headers?: any
) => Promise<TOutput> = async <TInput, TOutput>(
  apiServiceManager: ApiServiceManager,
  inputData: any,
  headers?: any
) => {
  const url = apiServiceManager.getUrl();
  const method = apiServiceManager.method;
  let defaultHeaders = new Headers();
  const tokenUpdater = apiServiceManager.tokenUpdater;
  const tokenProvider = apiServiceManager.tokenProvider;
  const token = tokenProvider && (await tokenProvider());
  defaultHeaders.append("Content-Type", "application/json;");
  if (token) {
    defaultHeaders.append("authorization", "Bearer " + token);
  }
  if (headers) {
    defaultHeaders = { ...defaultHeaders, ...headers };
  }
  let body: string | FormData | undefined =
    inputData && JSON.stringify(inputData);
  if (inputData instanceof FormData) {
    body = inputData;
  }

  return new Promise((resolve, reject) => {
    fetch(url, { headers: defaultHeaders, body, method })
      .then(async (response) => {
        // NOTE: Do NOT logOut()/reload() on 401 here. With Keycloak SSO a global
        // logout triggers a front-channel redirect, and a reload re-runs the
        // silent SSO re-auth — together they create an infinite refresh loop and
        // cancel every in-flight request. Token refresh is handled in getToken()
        // (keycloak.updateToken). Let the caller handle a genuine 401 instead.
        const text = await response.text();
        let json;
        try {
          json = text ? JSON.parse(text) : {};
        } catch (error) {
          reject(error);
          return;
        }
        if (json.successful === false || json.error) reject(json);
        resolve(json);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
